import validations from './index';
import { type } from 'modules/util/typecheck';

export function create(validation, error, ...defaultParams) {
  if (!type.isFunction(validations[validation])) {
    throw new Error(`Unknown validation: ${validation}`);
  }
  return (...params) => {
    const result = { passed: false };
    let args = params;
    if (typeof defaultParams !== 'undefined') args = params.concat(defaultParams);
    result.passed = validations[validation](...args);
    if (result.passed) result.error = undefined;
    return {
      validation,
      params,
      error,
      ...result,
    };
  };
}

export function run(validators, ...args) {
  let result = {};
  for (const validator of validators) {
    result = validator(...args);
    if (!result.passed) break;
  }
  return result;
}

export function runAll(validators, ...args) {
  const results = [];
  for (const validator of validators) {
    results.push(validator(...args));
  }
  return results;
}

export default {
  create,
  run,
  runAll,
};
